import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

export const bootstrap = new BootstrapBrowserBuilder('zillow-rental-manager-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: '/rental-manager/log',
    level: 'warn',
  })
  .withOnRegister(analytics.initialize)
  .build();
